/* ikl-cart.js - Ink Kulture storefront behaviour.
   Loaded from layout/theme.liquid and from several sections, so the guard
   below is essential: without it the delegated listeners register once per
   script tag and every click fires N times (quantity jumps, multiplied
   add-to-cart). */
(function () {
  'use strict';

  if (window.__iklStorefrontInit) return;
  window.__iklStorefrontInit = true;

  var CART_SECTION = 'cart-drawer-section';

  /* Build 034 speed: when IK Express (snippets/ik-checkout.liquid) runs the cart, the old drawer is never shown,
     so Add to cart no longer asks Shopify to re-render it (that added ~120 KB to every add on a phone).
     IK Express gets an "adding" event right away so the pill reacts instantly, and a failed add (for example,
     no more stock) shows a short message on the button instead of jumping to the cart page. */
  function isExpress() {
    return !!document.querySelector('script[data-ikx]') && !/[?&]ik_native=1/.test(location.search);
  }

  function refreshCartSection(sections) {
    if (!sections || !sections[CART_SECTION]) return false;
    var host = document.getElementById('shopify-section-' + CART_SECTION);
    if (!host) return false;
    var parsed = new DOMParser().parseFromString(sections[CART_SECTION], 'text/html');
    var fresh = parsed.getElementById('shopify-section-' + CART_SECTION);
    if (!fresh) return false;
    host.innerHTML = fresh.innerHTML;
    return true;
  }

  function openCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      try { drawer.open(); return true; } catch (e) {}
    }
    var trigger = document.querySelector('[on\\:click="#cart-drawer/open"]');
    if (trigger) { trigger.click(); return true; }
    var dialog = document.querySelector('#cart-drawer dialog');
    if (dialog && typeof dialog.showModal === 'function') {
      try { dialog.showModal(); return true; } catch (e) {}
    }
    return false;
  }

  function notifyCartChanged() {
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function flash(button, msg) {
    if (!button) return;
    var html = button.innerHTML;
    button.textContent = msg;
    setTimeout(function () { button.innerHTML = html; }, 2600);
  }

  var adding = false;

  function addToCart(variantId, quantity, button) {
    if (!variantId) { window.location.href = '/cart'; return; }
    if (adding) return;
    adding = true;
    var express = isExpress();
    var qty = Number(quantity) || 1;
    if (button) { button.setAttribute('aria-busy', 'true'); button.disabled = true; }
    if (express) document.dispatchEvent(new CustomEvent('ikx:adding', { detail: { variantId: Number(variantId), quantity: qty } }));
    var body = { items: [{ id: Number(variantId), quantity: qty }] };
    if (!express) body.sections = CART_SECTION;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root.replace(/\/$/, '') + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok) { var err = new Error('rejected'); err.status = res.status; throw err; }
          return data;
        });
      })
      .then(function (data) {
        if (express) document.dispatchEvent(new CustomEvent('ikx:added', { detail: data }));
        if (!express) refreshCartSection(data.sections);
        notifyCartChanged();
        if (!openCartDrawer()) window.location.href = '/cart';
      })
      .catch(function (err) {
        if (!express) { window.location.href = '/cart'; return; }
        document.dispatchEvent(new CustomEvent('ikx:add-failed'));
        flash(button, err && err.status === 422 ? 'No more stock' : 'Try again');
      })
      .finally(function () {
        adding = false;
        if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
      });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-ikl-add]');
    if (!btn) return;
    event.preventDefault();
    var scope = btn.closest('[data-ikl-scope]') || document;
    var qtyInput = scope.querySelector('[data-ikl-qty-input]');
    addToCart(btn.getAttribute('data-variant-id'), qtyInput ? qtyInput.value : 1, btn);
  });

  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-ikl-qty-step]');
    if (!step) return;
    event.preventDefault();
    var wrap = step.closest('.ikl-qty');
    if (!wrap) return;
    var input = wrap.querySelector('[data-ikl-qty-input]');
    if (!input) return;
    var current = parseInt(input.value, 10);
    if (isNaN(current)) current = 1;
    var delta = parseInt(step.getAttribute('data-ikl-qty-step'), 10);
    if (isNaN(delta)) delta = 1;
    input.value = Math.max(1, current + delta);
  });

  function initGallery(root) {
    if (root.dataset.iklGalleryReady === 'true') return;
    root.dataset.iklGalleryReady = 'true';
    var slides = [].slice.call(root.querySelectorAll('[data-ikl-slide]'));
    var thumbs = [].slice.call(root.querySelectorAll('[data-ikl-thumb]'));
    if (!slides.length) return;
    var index = 0;
    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.setAttribute('data-active', i === index ? 'true' : 'false'); });
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      if (thumbs[index] && thumbs[index].scrollIntoView) {
        thumbs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    root.querySelectorAll('[data-ikl-gallery-prev]').forEach(function (b) { b.addEventListener('click', function () { show(index - 1); }); });
    root.querySelectorAll('[data-ikl-gallery-next]').forEach(function (b) { b.addEventListener('click', function () { show(index + 1); }); });
    show(0);
  }

  function initCountdown(el) {
    if (el.dataset.iklCountdownReady === 'true') return;
    el.dataset.iklCountdownReady = 'true';
    var endHour = parseInt(el.getAttribute('data-ikl-countdown'), 10);
    if (isNaN(endHour)) endHour = 20;
    var deadline = new Date();
    deadline.setHours(endHour, 0, 0, 0);
    if (deadline <= new Date()) deadline.setDate(deadline.getDate() + 1);
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var diff = deadline - new Date();
      if (diff < 0) diff = 0;
      el.textContent = pad(Math.floor(diff / 3600000)) + ' : ' + pad(Math.floor((diff % 3600000) / 60000)) + ' : ' + pad(Math.floor((diff % 60000) / 1000));
    }
    tick();
    setInterval(tick, 1000);
  }

  function initDelivery(form) {
    if (form.dataset.iklDeliveryReady === 'true') return;
    form.dataset.iklDeliveryReady = 'true';
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var input = form.querySelector('input');
      var out = form.parentElement.querySelector('[data-ikl-delivery-result]');
      if (!out || !input) return;
      var pin = (input.value || '').trim();
      if (!/^[0-9]{6}$/.test(pin)) {
        out.textContent = 'Please enter a valid 6-digit PIN code.';
        out.style.color = 'var(--ikl-sale)';
        return;
      }
      out.textContent = form.getAttribute('data-ikl-success') || ('Delivering to ' + pin + '.');
      out.style.color = 'var(--ikl-cobalt)';
    });
  }

  function initStickyCta(bar) {
    if (bar.dataset.iklStickyReady === 'true') return;
    bar.dataset.iklStickyReady = 'true';
    var anchor = document.querySelector(bar.getAttribute('data-ikl-sticky-after') || '.ikl-pdp');
    if (!anchor || !('IntersectionObserver' in window)) { bar.classList.add('is-visible'); return; }
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }).observe(anchor);
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-ikl-modal-open]');
    if (opener) {
      var target = document.getElementById(opener.getAttribute('data-ikl-modal-open'));
      if (target) { target.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
      return;
    }
    var closer = event.target.closest('[data-ikl-modal-close]');
    if (closer) {
      var modal = closer.closest('.ikl-modal');
      if (modal) { modal.classList.remove('is-open'); document.body.style.overflow = ''; }
      return;
    }
    if (event.target.classList && event.target.classList.contains('ikl-modal')) {
      event.target.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  function boot(scope) {
    var s = scope || document;
    s.querySelectorAll('[data-ikl-gallery]').forEach(initGallery);
    s.querySelectorAll('[data-ikl-countdown]').forEach(initCountdown);
    s.querySelectorAll('[data-ikl-delivery-form]').forEach(initDelivery);
    s.querySelectorAll('[data-ikl-sticky]').forEach(initStickyCta);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();